import React from 'react';
import styles from './ListTable.Header.scss';
export var ListTableHeader = function ListTableHeader(_ref) {
  var dataTest = _ref.dataTest,
      children = _ref.children;
  return React.createElement("div", {
    className: styles.header,
    "data-test": dataTest
  }, children);
};